import Vue from 'vue'
import 'default-passive-events'
import './plugins/axios'
import App from './App.vue'
import './plugins/element.js'
import store from './store.js';
import VueRouter from 'vue-router';
import router from './router'
import ElementUI from 'element-ui'
import showToast from './components/toast/toast'
import showModal from './components/modal/modal'
import mAnchor from "./plugins/mAnchor";
import Storage from 'vue-ls';//ue-ls 是 Vue 的一个插件，用于操作 Local Storage(本地存储)、Session Storage(会话存储)、Memory(内存存储)。
import VueCompositionApi from '@vue/composition-api';
import 'umy-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css';
import '@/assets/element-variables.scss'
import '@/assets/font.css'
import '@/styles/index.scss' // global css
import UmyUi from 'umy-ui'
import animate from "animate.css";
import {gFunc} from "@/globalFunc";
import FileSaver from 'file-saver'
import * as utils from '@/utils/index'
import Pagination from "@/components/Pagination";
import {getToken} from "@/utils/auth";
import {BigNumber} from "bignumber.js";

import {RegisterFilter} from "@/utils/filter";
import {RegisterDirectives} from "@/utils/directives";

// vue-ls 的配置
const options = {
    namespace: '', // key prefix
    name: 'ls', // name variable Vue.[ls] or this.[$ls],
    storage: 'local', // storage name session, local, memory
};
Vue.use(ElementUI)
Vue.use(UmyUi)
Vue.use(Storage, options);
Vue.use(VueRouter);
Vue.use(mAnchor)
Vue.use(VueCompositionApi);
Vue.use(animate);
// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('NoPermission', resolve => require(['@/views/error/401'], resolve))
Vue.component('ButtonSubmit', resolve => require(['@/components/ButtonSubmit'], resolve))
Vue.component('UserSearch', resolve => require(['@/components/user/UserSearch'], resolve))
Vue.component('CustomerSearch', resolve => require(['@/components/customer/CustomerSearch'], resolve))
Vue.component('PinYinMatchSelect', resolve => require(['@/components/pinYinMatchSelect'], resolve))
Vue.component('PlatformSelect', resolve => require(['@/components/platformSelect/PlatformSelect'], resolve))
Vue.component('ExportLink', resolve => require(['@/components/export/ExportLink'], resolve))
Vue.component('MonthSelectGroup', resolve => require(['@/components/SearchTools/MonthSelectGroup'], resolve))
Vue.component('YearSelectGroup', resolve => require(['@/components/SearchTools/YearSelectGroup'], resolve))
Vue.prototype.showToast = function (data) {
    showToast(data)
}
Vue.prototype.showModal = function (data) {
    showModal(data)
}
Vue.prototype.msgSuccess = function (msg) {
    this.$message({showClose: true, message: msg, type: "success"});
}

Vue.prototype.msgError = function (msg) {
    this.$message({showClose: true, message: msg, type: "error", duration: 5000});
}
Vue.prototype.msgWarn = function (msg) {
    this.$message({showClose: true, message: msg, type: "warning", duration: 5000});
}
Vue.prototype.msgInfo = function (msg) {
    // this.$message.info(msg);
    this.$message({showClose: true, message: msg, type: "info"});
}

Vue.prototype.getToken = getToken
Vue.prototype.gFunc = gFunc
Vue.prototype.FileSaver = FileSaver
Vue.prototype.$utils = utils
Vue.prototype.$bigNumber = BigNumber
Vue.prototype.$EventBus = new Vue() // EventBus

// 数组根据索引删除 ，且不修改原数组
Array.prototype.delete = function (delIndex) {
    const temArray = [];
    const array = this
    array.forEach(function (item, index) {
        if (index !== delIndex) {
            temArray[index] = array[index];
        }
    })
    return temArray;
}
/**
 * 修改 vue-router 的push方法
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject);
    }
    return originalPush.call(this, location);//.catch(err => err)
}

// 注册Filter
new RegisterFilter(Vue);
// 注册Directives
new RegisterDirectives(Vue);

new Vue({
    router,
    store,
    render: (h) => {
        /**
         * 初始化
         */

        Date.prototype.getTimeformat = function (format = 'YY-MM-DD hh:mm:ss') {
            let year = this.getFullYear(),
                month = this.getMonth() + 1,//月份是从0开始的
                day = this.getDate(),
                hour = this.getHours(),
                min = this.getMinutes(),
                sec = this.getSeconds();
            let preArr = Array.apply(null, Array(10)).map(function (elem, index) {
                return '0' + index;
            });////开个长度为10的数组 格式为 00 01 02 03

            let newTime = format.replace(/YY/g, year)
                .replace(/MM/g, preArr[month] || month)
                .replace(/DD/g, preArr[day] || day)
                .replace(/hh/g, preArr[hour] || hour)
                .replace(/mm/g, preArr[min] || min)
                .replace(/ss/g, preArr[sec] || sec);

            return newTime;
        }

        return h(App)
    }
}).$mount('#app')
